import React from 'react';

const ShowLoad = ({ addStyle }) => (
  <div className='loadingio-spinner-eclipse-ebyrvwal62m' style={addStyle}>
    <div className='ldio-yuuyfzy0ot'>
      <div></div>
    </div>
  </div>
);

export default ShowLoad;
